<template>
  <div>
    <ViewHeader />

    <div class="px-5 mt-3">
      <Icon
        :width="24"
        :viewBox="26"
        :icon="'shield-key'"
      />
      <h5 class="font-weight-light text--secondary">
        {{ $t('formValidate.title') }}
      </h5>
      <h2 class="mt-0">
        ¡{{ $t('formValidate.greeting') }} {{ customer.name }}!
      </h2>
      <p class="ma-0 py-3 pb-5 text--secondary">
        {{ $t('formValidate.text') }} <b>{{ customer.email }}</b>
      </p>
    </div>
    <v-card
      :loading="validationEmail.loading || resendValidationEmail.loading"
      :disabled="validationEmail.loading || resendValidationEmail.loading"
      elevation="0"
      class="px-5"
      rounded="0"
      loader-height="3"
    >
      <form class="mt-5" v-on:submit.prevent="submitHandler">
        <div>
          <v-otp-input
            :length="6"
            type="number"
            v-model="form.token"
            required
            dense
          ></v-otp-input>
        </div>
        <div class="text-center py-5">
          ¿No has recibido el código?
          <v-btn
            elevation="0"
            small
            class="text-center text-capitalize px-1"
            text
            style="text-decoration: underline"
            :loading="resendValidationEmail.loading"
            :disabled="resendValidationEmail.loading"
            @click="resendEmailToken"
          >
            {{ $t('formValidate.resendButton') }}
          </v-btn>
        </div>
        <v-row class="mt-4 justify-center">
          <v-col cols="4">
            <v-btn
              class="font-weight-bold"
              type="button"
              rounded
              block
              depressed
              @click="onExit"
              color="white"
            >
              {{ $t('basics.exit') }}
            </v-btn>
          </v-col>
          <v-col cols="8">
            <v-btn
              v-if="btnPrimaryConfig.data"
              class="font-weight-bold"
              type="submit"
              rounded
              block
              elevation="1"
              :color="btnPrimaryConfig.data.btn "
              :style="`color: ${btnPrimaryConfig.data.text}`"
              :loading="validationEmail.loading"
              :disabled="validationEmail.loading"
              data-action="Botón continuar del formulario inicial"
              data-position="0"
              data-analityc-actuator="saveAnalitycHistory"
            >
              {{ $t('basics.continue') }}
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </v-card>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import MainService from '@/services/MainService'

@Component({
  components: {
    ViewHeader: () => import(/* webpackPrefetch: true */ '@/components/ViewHeader.vue'),
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  props: {
    customer: {
      type: Object,
      default: null
    }
  },
  computed: {
    btnPrimaryConfig () {
      return this.$organization.btnPrimaryConfig()
    },
    formIsMain () {
      return this.$organization.formIsMain()
    }
  }
})
export default class Form extends Vue {
  data () {
    return {
      resendValidationEmail: {
        loading: false
      },
      validationEmail: {
        loading: false
      },
      form: {
        token: ''
      }
    }
  }

  onExit () {
    this.saveAnalitycsEvent('El cliente no procedio a validar el email', 'Botón salir')
    this.$router.replace({ path: '/' })
  }

  next () {
    if (!this.$organization.smartMode() && this.formIsMain.isActive) {
      this.$router.replace({ path: '/categories' })
    } else if (this.$organization.calendaryModule() && this.$organization.directCallModule() && this.formIsMain.isActive) {
      this.$router.replace({ path: '/attention-types' })
    } else if (this.$route.query.nextPath) {
      this.$router.replace({ path: this.$route.query.nextPath })
    } else if (this.$organization.calendaryModule()) {
      this.$router.replace({ path: '/calendar', query: { requestChannel: true } })
    } else {
      this.$router.replace({ path: '/permissions', query: { requestChannel: true } }).catch((error) => {})
    }
  }

  saveAnalitycsEvent (detail, action) {
    this.$ocularAnalitycs.widgetAnalitycsEvent({
      action,
      detail,
      actionType: 'STAH',
      functionality: 1,
      historyInteractionType: 'OSIFDV'
    })
  }

  resendEmailToken () {
    this.resendValidationEmail.loading = true

    const data = {
      route: 'ocular/widget/resend-validation-email',
      params: {
        email: this.customer.email,
        name: this.customer.name,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      }
    }

    MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.saveAnalitycsEvent('El cliente solicitó reenviar correo', 'Botón reenviar el correo')
          this.$store.commit('notify', {
            color: 'success',
            message: this.$t('formValidate.resendText')
          })
        } else if (res.statusCode === 11) {
          this.$store.commit('notify', {
            color: 'warning',
            message: this.$t('maintenance.text')
          })
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.resendValidationEmail.loading = false
      })
  }

  submitHandler () {
    this.validationEmail.loading = true

    const data = {
      route: 'ocular/widget/validation-email',
      params: {
        token: this.form.token,
        email: this.customer.email
      }
    }

    MainService.post(data)
      .then((response) => {
        const res = response.data

        if (res.statusCode === 0) {
          this.saveAnalitycsEvent('El cliente valido el correo', 'Botón continuar del formulario validar email')

          this.next()
        } else if (res.statusCode === 11) {
          this.$store.commit('notify', {
            color: 'warning',
            message: this.$t('maintenance.text')
          })
        } else {
          this.$store.commit('notify', {
            color: 'error',
            message: this.$t('formValidate.errorText')
          })
        }
      })
      .catch((e) => {
        console.log(e)
      })
      .then(() => {
        this.validationEmail.loading = false
      })
  }
}
</script>
